module.exports = __webpack_public_path__ + "img/najib_zahid.cdf2aa77.jpg";